<template>
  <v-item-group
    v-model="selected"
    class="d-flex flex-column"
    :multiple="multiple"
  >
    <draggable v-model="dragFields" v-bind="draggableProps">
      <template v-for="(item, index) in dragFields">
        <slot
          v-bind="{
            item: item,
            index: index,
            key: getItemKey(item),
            isActive: isPanelOpen(item),
          }"
        ></slot>
      </template>
    </draggable>
  </v-item-group>
</template>

<script>
import { typeHelpers } from '@/modules';
import Draggable from 'vuedraggable';

export default {
  name: 'DraggablePanels',
  components: { Draggable },
  props: {
    open: {
      type: Array,
      default: () => [],
      validator: (item) => typeHelpers.isArrayOfType(item, Object),
    },
    items: {
      type: Array,
      default: () => [],
      validator: (item) => typeHelpers.isArrayOfType(item, Object),
    },
    itemKey: {
      type: String,
      required: true,
    },
    panelClass: {
      type: String,
      default: null,
    },
    showCollapseButton: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    draggableProps: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:open', 'update:items'],
  computed: {
    selected: {
      set: function (openPanels) {
        if (!this.multiple) {
          openPanels = [openPanels];
        }
        const selectedItems = openPanels
          .map((v) => this.getItemFromKey(v))
          .filter((v) => !!v);
        this.$emit('update:open', selectedItems);
      },
      get: function () {
        let openPanels = this.open
          .filter((item) => !!item)
          .map((item) => this.getItemKey(item));
        if (!this.multiple) {
          openPanels = openPanels[0];
        }
        return openPanels;
      },
    },
    dragFields: {
      set: function (value) {
        this.$emit('update:items', value);
      },
      get: function () {
        return this.items;
      },
    },
  },
  methods: {
    isPanelOpen(item) {
      const itemKey = this.itemKey;
      return this.open.some((x) => x[itemKey] === item[itemKey]);
    },
    getItemKey(item) {
      return item[this.itemKey];
    },
    getItemFromKey(key) {
      return this.items.find((i) => i[this.itemKey] === key);
    },
  },
};
</script>
